// components/onboarding/OnboardingWelcomeModal.jsx
import React from 'react';
import { useOnboarding } from '../../context/OnboardingContext';
import { PiDog } from 'react-icons/pi';
import { FiCalendar, FiUser, FiArrowRight, FiX } from 'react-icons/fi';
import '../../styles/Onboarding.css';

/**
 * OnboardingWelcomeModal
 *
 * Initial modal shown to first-time users asking if they want
 * to take a guided tour of the application.
 */
const OnboardingWelcomeModal = () => {
    const { showWelcomeModal, startOnboarding, skipOnboarding } = useOnboarding();

    if (!showWelcomeModal) {
        return null;
    }

    return (
        <div className="onboarding-modal-overlay">
            <div className="onboarding-welcome-modal">
                {/* Close button */}
                <button
                    className="onboarding-close-btn"
                    onClick={skipOnboarding}
                    title="Zamknij"
                    aria-label="Zamknij"
                >
                    <FiX />
                </button>

                {/* Header */}
                <div className="onboarding-welcome-header">
                    <div className="onboarding-welcome-icon">
                        <PiDog />
                    </div>
                    <h2>Witaj w PetBoard!</h2>
                    <p className="onboarding-welcome-subtitle">
                        Cieszymy się, że jesteś z nami
                    </p>
                </div>

                {/* Body */}
                <div className="onboarding-welcome-body">
                    <p className="onboarding-welcome-message">
                        Czy chcesz zobaczyć krótki przewodnik po aplikacji?
                        Pokażemy Ci najważniejsze funkcje w kilku prostych krokach.
                    </p>

                    <div className="onboarding-features-preview">
                        <h4>Co poznasz:</h4>
                        <ul>
                            <li>
                                <span className="feature-icon"><PiDog /></span>
                                <span>Jak dodać swojego psa</span>
                            </li>
                            <li>
                                <span className="feature-icon"><FiCalendar /></span>
                                <span>Jak rezerwować treningi</span>
                            </li>
                            <li>
                                <span className="feature-icon"><FiUser /></span>
                                <span>Jak zarządzać swoim kontem</span>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Actions */}
                <div className="onboarding-welcome-actions">
                    <button
                        className="onboarding-btn onboarding-btn-primary"
                        onClick={startOnboarding}
                    >
                        Rozpocznij przewodnik
                        <FiArrowRight />
                    </button>
                    <button
                        className="onboarding-btn onboarding-btn-secondary"
                        onClick={skipOnboarding}
                    >
                        Pomiń, znam już aplikacje
                    </button>
                </div>

                {/* Footer note */}
                <p className="onboarding-welcome-footer">
                    Możesz zawsze wrócić do tego przewodnika później w zakładce Moje konto.
                </p>
            </div>
        </div>
    );
};

export default OnboardingWelcomeModal;
